var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.836 5.896 9.852 9.09a1.8 1.8 0 0 0-.763.763l-3.193 6.984c-.368.805.462 1.636 1.268 1.268l6.984-3.193a1.8 1.8 0 0 0 .763-.763l3.193-6.984c.368-.806-.462-1.636-1.268-1.268m-3.743 7.197a1.545 1.545 0 1 1-2.186-2.186 1.545 1.545 0 0 1 2.185 2.186M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0m0 21.677c-5.336 0-9.677-4.34-9.677-9.677S6.663 2.323 12 2.323s9.677 4.34 9.677 9.677-4.34 9.677-9.677 9.677"
  }))));
};
export default SvgCompass;